import * as api from '../../api';

import { DoctorAppointmentProfileView } from './DoctorAppointmentProfileView';
import { InfoMessage } from '../../components/InfoMessage';
import { LinkText } from '../../components/LinkText';
import { htmlFromMarkdown } from '../../utils/markdown';
import * as PhoneNumber from '../../utils/phoneNumber';

import styles from './index.module.css';
import { Trans } from 'react-i18next';

interface Props {
  index: number;
  appointment: api.NotificationIntent.Appointment;
}

export const AppointmentsConfirmationCard: React.FC<Props> = ({
  index,
  appointment,
}) => {
  const { encounter, practice, provider, virtualVisit } = appointment;
  return (
    <div key={index}>
      {
        <DoctorAppointmentProfileView
          key={appointment.encounter.id}
          id={appointment.encounter.id}
          startTime={appointment.encounter.startTime}
          arrivalTime={appointment.encounter.arrivalTime || undefined}
          status={appointment.encounter.status || undefined}
          provider={provider}
          practice={practice}
          virtualVisit={virtualVisit}
          hideEncounterStartTimeByVisitKind={
            appointment.preferences.hideEncounterStartTimeByVisitKind
          }
          kindOfVisit={appointment.encounter.kindOfVisit || undefined}
        >
          {appointment.encounter.status ===
            api.EhrTimeSlot.AppointmentStatus.CancellationIntended && (
            <InfoMessage variant="warning">
              <Trans
                i18nKey="This appointment is still scheduled. To finish cancelling or rescheduling, please call <link />."
                defaults="This appointment is still scheduled. To finish cancelling or rescheduling, please call <link />."
                components={{
                  link: (
                    <LinkText
                      className={styles.Link}
                      to={`tel:${appointment.practice.phoneNumber}`}
                      title={PhoneNumber.prettify(
                        appointment.practice.phoneNumber,
                      )}
                    />
                  ),
                }}
              />
            </InfoMessage>
          )}
        </DoctorAppointmentProfileView>
      }
      {!!encounter.patientInstructions && (
        <div className={styles.Instructions}>
          <div
            className={styles.Dialog}
            dangerouslySetInnerHTML={{
              __html: htmlFromMarkdown(encounter.patientInstructions),
            }}
          />
        </div>
      )}
      <div />
    </div>
  );
};
